import React from "react";
import { HiOutlineGift } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneParty } from "../../../lib/sysNavigation/SysNavigation";

type PartyRow = {
  party_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<PartyRow>
    type={_TYPES_.PARTY}
    title="Parties"
    subtitle="Parties promoted on the public site."
    icon={<HiOutlineGift className="h-5 w-5" />}
    addRoute="/data/party/add"
    editRoute="/data/party/edit"
    pushOne={pushOneParty}
    dataKey="parties"
    countKey="partiesCount"
    idField="party_id"
  />
);

export default Overview;
